import React from 'react';
import styles from './Cells.module.scss';

export function AssetShortNoteCell({ note }) {
  return <div className={styles.assetShortNote}>{note || ''}</div>;
}
